/* Presentation enhancement only; native Shopify components own variants and cart writes. */
(() => {
  const root = document.querySelector('.swf-product');
  if (!root) return;
  let cartIds = new Set();
  let refreshVersion = 0;
  let visibleMediaColor;
  const cartUrl = `${window.Shopify?.routes?.root || '/'}cart`;
  function enhance() {
    const content = root.querySelector('.product-details > .group-block > .group-block-content');
    if (!content) return;
    for (const block of content.children) {
      if (block.matches('.text-block') && (block.classList.contains('swf-pdp-guarantee') || block.textContent.includes('Love it or get a refund.'))) {
        block.classList.add('swf-pdp-guarantee');
        const message = block.querySelector('p');
        if (message && !message.querySelector('.swf-guarantee-policy')) {
          message.innerHTML = '<strong class="swf-refund-heading">Love it or get a refund.</strong><span class="swf-refund-detail">No return needed. Contact us within <a class="swf-guarantee-policy" href="' + (window.Shopify?.routes?.root || '/') + 'policies/refund-policy">30 days of delivery</a>.</span>';
        }
        if (!content.querySelector('.swf-dispatch-note')) {
          const dispatch = document.createElement('p');
          dispatch.className = 'swf-dispatch-note';
          dispatch.textContent = 'Typically dispatches in 2-3 days. Delivery: 2-8 business days after dispatch.';
          block.after(dispatch);
        }

        if (!block.querySelector('.swf-guarantee-shield')) {
          const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          icon.classList.add('swf-guarantee-shield');
          icon.setAttribute('viewBox', '0 0 24 24');
          icon.setAttribute('aria-hidden', 'true');
          icon.setAttribute('fill', 'none');
          icon.setAttribute('stroke', 'currentColor');
          icon.setAttribute('stroke-width', '1.5');
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M12 3 3 7v6c0 5 9 9 9 9s9-4 9-9V7L12 3Z M8 12l3 3 5-6');
          icon.append(path);
          block.prepend(icon);
        }
      }
      if (block.textContent.includes('Premium T-Shirts') && block.textContent.includes('Fast Shipping')) block.classList.add('swf-assurance-row');

      const title = block.querySelector('h1');
      if (title) {
        block.classList.add('swf-pdp-title');
        if (!block.querySelector('.swf-product-breadcrumbs')) {
          const nav = document.createElement('nav');
          nav.className = 'swf-product-breadcrumbs';
          nav.setAttribute('aria-label', 'Breadcrumb');
          const home = document.createElement('a');
          home.href = window.Shopify?.routes?.root || '/';
          home.textContent = 'Home';
          const shop = document.createElement('a');
          shop.href = (window.Shopify?.routes?.root || '/') + 'collections/all';
          shop.textContent = 'Shop all';
          const current = document.createElement('span');
          current.setAttribute('aria-current', 'page');
          current.textContent = title.textContent.trim();
          nav.append(home, document.createTextNode(' / '), shop, document.createTextNode(' / '), current);
          title.before(nav);
        }
      }

      if (block.textContent.trim().includes('Printed & Shipped in USA')) block.classList.add('swf-pdp-origin');
      if (block.matches('product-price') || block.querySelector('product-price')) block.classList.add('swf-pdp-price');
    }
    const colorOption = [...root.querySelectorAll('[data-option-name]')].find(option => /^(color|colour)$/i.test(option.dataset.optionName));
    const selectedColor = colorOption?.querySelector('[data-selected-text-target]')?.textContent.trim();
    const color = visibleMediaColor === undefined ? selectedColor : visibleMediaColor;
    const gallery = root.querySelector('.product-information__media');
    if (gallery) {
      let caption = gallery.querySelector('.swf-shown-color');
      if (!caption) {
        caption = document.createElement('p');
        caption.className = 'swf-shown-color';
        caption.setAttribute('aria-live', 'polite');
        gallery.append(caption);
      }
      caption.hidden = !color;
      const message = color ? `Shown in ${color}` : '';
      if (caption.textContent !== message) caption.textContent = message;
    }
    let link = root.querySelector('.swf-view-cart');
    if (!link) {
      link = document.createElement('a');
      link.className = 'swf-view-cart';
      link.href = cartUrl;
      link.textContent = 'View cart →';
      link.hidden = true;
      const guarantee = [...content.children].find(block => block.matches('.text-block') && (block.classList.contains('swf-pdp-guarantee') || block.textContent.includes('Love it or get a refund.')));
      const anchor = guarantee || root.querySelector('product-form-component')?.closest('.buy-buttons-block');
      if (anchor) anchor.after(link);
      else content.append(link);
    }
    const form = root.querySelector('product-form-component');
    const id = form?.querySelector('[name="id"]')?.value;
    const added = Boolean(id && cartIds.has(String(id)));
    const button = form?.querySelector('.add-to-cart-button');
    if (button) {
      button.classList.toggle('swf-added', added);
      button.querySelectorAll('.add-to-cart-text__content').forEach(text => {
        if (!button.disabled) text.textContent = added ? 'Added to cart' : 'Add to cart';
      });
    }
    link.hidden = !added;
    const sizeLink = root.querySelector('#size-guide-modal-button');
    if (sizeLink && !sizeLink.hasAttribute('role')) {
      sizeLink.setAttribute('role', 'button');
      sizeLink.tabIndex = 0;
      sizeLink.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); sizeLink.click(); }
      });
    }
  }
  async function refreshCart() {
    const version = ++refreshVersion;
    try {
      const response = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (version !== refreshVersion) return;
      cartIds = new Set(cart.items.map(item => String(item.variant_id)));
      enhance();
    } catch { /* Leave native form usable when cart status cannot be fetched. */ }
  }
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; observer.disconnect(); enhance(); observer.observe(root, { childList: true, subtree: true }); });
  });
  enhance();
  observer.observe(root, { childList: true, subtree: true });
  document.addEventListener('cart:update', event => {
    if (event.detail?.data?.didError) return;
    if (root.contains(event.target) && event.detail?.data?.source === 'product-form-component') {
      cartIds.add(String(event.detail.sourceId));
      enhance();
    }
    refreshCart();
  });
  root.addEventListener('slideshow:select', event => {
    if (!event.target.closest('.product-information__media')) return;
    const slide = event.detail?.slide;
    if (!slide) return;
    visibleMediaColor = slide.querySelector('[data-swf-media-color]')?.dataset.swfMediaColor || '';
    enhance();
  });
  document.addEventListener('variant:update', () => {
    visibleMediaColor = undefined;
    requestAnimationFrame(enhance);
  });
  window.addEventListener('pageshow', refreshCart);
  refreshCart();
})();
